import { ICONS_INSIGHTS } from "@/const/insights-constants"
import { InsightsCell } from "@/molecules/InsightsCell"

import type { TFunction } from "@/hooks/useTranslation"
import type { ToolInsightsValues } from "./ToolInsightsCell.types"

const REQUIRED_ACCESS_ITEMS = [
  ICONS_INSIGHTS.networkAccess,
  ICONS_INSIGHTS.fileSystemAccess,
  ICONS_INSIGHTS.executionAccess
]

export const ToolInsightsCell = (
  t: TFunction,
  options: { showRequiredAccess: boolean }
) => {
  const items = options.showRequiredAccess
    ? [ICONS_INSIGHTS.runtime, ...REQUIRED_ACCESS_ITEMS]
    : [ICONS_INSIGHTS.runtime]

  return function ToolInsightsCellComponent({
    tag,
    id,
    ...values
  }: Partial<ToolInsightsValues>) {
    return (
      <InsightsCell
        hide
        id={id}
        items={items}
        values={values}
        t={t}
        tag={tag}
      />
    )
  }
}
